// components/EditReviewModal.js
"use client";

import {
  Grid,
  Button,
  Form,
  TextArea,
  GridRow,
  GridColumn,
} from "semantic-ui-react";
import Slidersingle from "react-rangeslider";
import { FormError } from "../../../components/index.js";
import ModalWrapper from "../../Neighborhood/[id]/ModalWrapper.js";

export default function EditReviewModal({
  modaleditreviewIsopen,
  closeeditreviewmodal,
  customStyles,
  valueclub,
  formatvalueclub,
  handleChangeclub,
  publicrate_err,
  valuequality,
  formatvaluequality,
  handleChangequality,
  curbrate_err,
  keywordfirst,
  handlekeywordfirstChange,
  keywordsec,
  handlekeywordsecChange,
  keywordthird,
  handlekeywordthirdChange,
  houseberrytakereview,
  reviewChange,
  description_err_status,
  description_err_msg,
  EditreviewFormSubmit,
  page,
}) {
  return (
    <ModalWrapper
      isOpen={modaleditreviewIsopen}
      onRequestClose={closeeditreviewmodal}
      style={customStyles}
      contentLabel="Edit Review Modal"
    >
      {/* Close Button */}
      <div className="slider_modal_btn">
        <span
          onClick={closeeditreviewmodal}
          data-primary={true}
          style={{ marginTop: "10px" }}
        >
          X
        </span>
      </div>

      <Form style={{ width: "97%" }} className="nh_details_edit_form">
        <Grid className="modal_grid">
          {/* Rating: Public Spaces */}
          <GridRow className="rating_comman detailnh_rating">
            <GridColumn mobile={16} tablet={16} computer={16}>
              <span>
                <strong>
                  {page === "city"
                    ? "Rate City by these factors:"
                    : "Rate Neighborhood by these factors:"}
                </strong>
              </span>
            </GridColumn>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <p className="rating_title">
                <strong>Public Spaces</strong>&nbsp; (access to parks, public
                squares, sidewalks & walking trails)
              </p>
              <div className="slider custom-labels">
                <Slidersingle
                  min={0}
                  max={5}
                  value={parseFloat(valueclub).toFixed(1)}
                  labels={["0", "1", "2", "3", "4", "5"]}
                  format={formatvalueclub}
                  onChange={handleChangeclub}
                  step={0.1}
                />
              </div>
            </GridColumn>
            <GridColumn mobile={16} tablet={16} computer={16}>
              {publicrate_err && (
                <span className="err_rating_public">Please provide rating</span>
              )}
            </GridColumn>
          </GridRow>

          {/* Rating: Curb Appeal */}
          <GridRow className="rating_comman detailnh_rating">
            <GridColumn mobile={16} tablet={16} computer={16}>
              <p className="rating_title">
                <strong>Curb Appeal</strong>&nbsp;(how well kept and appealing
                are the houses and streets)
              </p>
              <div className="slider custom-labels">
                <Slidersingle
                  min={0}
                  max={5}
                  value={parseFloat(valuequality).toFixed(1)}
                  labels={["0", "1", "2", "3", "4", "5"]}
                  format={formatvaluequality}
                  onChange={handleChangequality}
                  step={0.1}
                />
              </div>
            </GridColumn>
            <GridColumn mobile={16} tablet={16} computer={16}>
              {curbrate_err && (
                <span className="err_rating_curb">Please provide rating</span>
              )}
            </GridColumn>
          </GridRow>

          {/* Keywords */}
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <span>
                <strong>
                  Provide top Key Words Or Phrases that best describe the
                  Neighborhood:
                </strong>
              </span>
            </GridColumn>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <Form.Field>
                <input
                  type="text"
                  value={keywordfirst}
                  onChange={handlekeywordfirstChange}
                  placeholder="Please Enter Your Keyword"
                />
              </Form.Field>
              <Form.Field>
                <input
                  type="text"
                  value={keywordsec}
                  onChange={handlekeywordsecChange}
                  placeholder="Please Enter Your Keyword"
                />
              </Form.Field>
              <Form.Field>
                <input
                  type="text"
                  value={keywordthird}
                  onChange={handlekeywordthirdChange}
                  placeholder="Please Enter Your Keyword"
                />
              </Form.Field>
            </GridColumn>
          </GridRow>

          {/* Review Text */}
          <GridColumn mobile={16} tablet={16} computer={16}>
            <span>
              <strong>Write Neighborhood Review and Description:</strong>
            </span>
          </GridColumn>
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <TextArea
                placeholder="Edit caption"
                defaultValue={
                  houseberrytakereview &&
                  houseberrytakereview.length > 0 &&
                  decodeURIComponent(houseberrytakereview[0].description)
                }
                name="editor_review"
                style={{ width: "100%" }}
                onChange={(e) => reviewChange(e)}
              />
              <FormError
                err_status={description_err_status}
                err_msg={description_err_msg}
              />
            </GridColumn>
          </GridRow>

          {/* Submit */}
          <div className="caption_btn">
            <Button
              type="submit"
              primary
              style={{ marginTop: "10px" }}
              onClick={EditreviewFormSubmit}
            >
              Save
            </Button>
          </div>
        </Grid>
      </Form>
    </ModalWrapper>
  );
}
